import req from 'shared/req';
import {errorMessage, flashMessage} from 'shared/actions/notifications';

export const createStudent = (data) => (dispatch) =>
  req({
    url: '/v1/imported-account',
    method: 'post',
    data,
  })
    .then((student) => {
      dispatch(flashMessage('Student saved!'));
      return student;
    })
    .catch(() => {
      dispatch(errorMessage());
    });
